import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import ErrorPage from '../components/error-page';
import { ROUTERS } from '../constants/common.constants';
import UserRegisterVendor from '../pages/register';
import PageNotFound from '../pages/page-not-found';
import Home from '../pages/home';

export const routerObjects: RouteObject[] = [
  {
    path: '*',
    Component: () => {
      return <PageNotFound />;
    },
  },
  {
    children: [
      {
        path: ROUTERS.REGISTER,
        element: <UserRegisterVendor />,
      },
      {
        path: ROUTERS.HOME,
        element: <Home />,
      },
    ],
  },
];

const assignRouter = (
  routerObjects: RouteObject[] | null | undefined,
  values: Partial<RouteObject>
) => {
  if (!routerObjects) {
    return;
  }
  for (const routerObject of routerObjects) {
    Object.assign(routerObject, values);
    if (routerObject.children?.length) {
      assignRouter(routerObject.children, values);
    }
  }
};

export function createRouter(): ReturnType<typeof createBrowserRouter> {
  assignRouter(routerObjects, {
    ErrorBoundary: ErrorPage,
  });
  return createBrowserRouter(routerObjects);
}
